import { render, staticRenderFns } from "./ServicesWrapper.vue?vue&type=template&id=6e0dc90c&scoped=true&"
import script from "./ServicesWrapper.vue?vue&type=script&lang=js&"
export * from "./ServicesWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ServicesWrapper.vue?vue&type=style&index=0&id=6e0dc90c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0dc90c",
  null
  
)

export default component.exports